export default __webpack_public_path__ + "static/media/project6-mac.b7ecfa74.png";